import React , {useState , useEffect} from 'react';
import {  doc, getDoc , db , getDocs , collection , setDoc ,query , where , deleteDoc } from '../firebase';
import './SinglePackage.css';
import { useParams  , Link } from 'react-router-dom';
import {  Carousel } from 'react-bootstrap';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PackageComponent from '../components/PackageComponent';
import { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import SideFooter from '../components/SideFooter';
import Footer from '../components/Footer';


const SinglePackage = () => {

  const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

  const [userAddedPackage , setUserAddedPackage] = useState(true);

  const [foundedCartPackage , setFoundedCartPackage] = useState('');


  let { packageId } = useParams();
  
  const [ experinceArray , setExperincesArray ] = useState([]);



  const [packageObject , setPackageObject] = useState({});

  const [loading , setLoading] = useState(false);

  const {photographers} = useContext(AppContext);
  const {hotels} = useContext(AppContext);
  const { tours } = useContext(AppContext);

  const [photographersArray] = photographers;
  const [hotelArray] = hotels;
  const [tourGuideArray] = tours;

  useEffect(() => {

      const checkIfPackagedAdded = async () => {
        const q = query(collection(db, `cart ${user.id}`), where("id", "==", packageId )  );
         
        const querySnapshot = await getDocs(q);
      
        const packagesDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';
    
     setFoundedCartPackage(packagesDataArray);
       
        if (packagesDataArray.length === 0 ) {
          setUserAddedPackage(false);
        }
      }

      checkIfPackagedAdded();
 

  } , [userAddedPackage]);

  useEffect(() => {

    window.scrollTo(0,0);
    
    const getProductsFromFirestore = async () => {
      const docRef = doc(db, "packages", packageId );
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
 
  setPackageObject(docSnap.data());
} else {

  setPackageObject(null)
}


    }
    getProductsFromFirestore();

  } , []);

  useEffect(() => {

    setLoading(true);

    setTimeout(() => {
       setLoading(false);
    } , 600)

 } , [])

 useEffect(  () => {

  const getExperincesData = async () => { 
    const querySnapshot = await getDocs(collection(db, "experiences"));
    const experincesdataarray = querySnapshot.docs
    .map((doc) => ({ ...doc.data(), id: doc.id }));
      
    setExperincesArray(experincesdataarray);
   
  }
  getExperincesData();
} , []);
  


  let starsArray = [];

  const loopThrought = (param) => {
      for (let i =0; i < param; i++ ) {
          starsArray.push(i);
      }
     
  }



  const makeid = (length) =>  {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

  const addCartToDb = async () => {

    setUserAddedPackage(!userAddedPackage);

    const cart = await setDoc(doc(db, `cart ${user.id}`, makeid(20)), {
      name : packageObject.name,
      image: packageObject.image,
      price: packageObject.price,
      service_provider: 'Tourist Compass',
      description : packageObject.description,
      status: 'wait-payment',
      id: packageId
    
      
     
      });

  }

  const removeCartFromDb = async () => { 
    setUserAddedPackage(!userAddedPackage);
    await deleteDoc(doc(db, `cart ${user.id}`, foundedCartPackage[0].id ));

  }

  return (
    <div className='main_homepage ' >


  <NavbarHome />

  <div className="container-mid">


    
<div className='single_main_package' >
    

    <div className="grid_single_package single_package_div ">

      <div className="package_image">

      <Carousel controls={false} pause={false} className="bg-white mt-2" style={{width:'100%',height:'240px'}}>
                        {
                            packageObject.photos &&  packageObject.photos.map(function(item,i){
                                return <Carousel.Item key={i} interval={3000} className="p-0 text-end hand" style={{width:'100%',height:'240px'}}>
                                    <img src={item} className="" style={{objectFit:'cover',objectPosition:'center',width:'100%',height:'240px'}} />
                                </Carousel.Item>
                            })
                        }
                    </Carousel>

  

      </div>
      <div className="package_info">

      <h1 className="headline_location"> { packageObject ? packageObject.name : '' } </h1>
      

       <div className="mt-1"></div>
  {loopThrought(packageObject ? packageObject.stars : 1)}
            {starsArray && starsArray.map(( ) => (
                <img src="/images/icons/star.png" alt="" className="star_icon_small" />
            ))}
<br />
    <button className="btn_category mt-1"> 
    { packageObject ? packageObject.refere_location  : ''  } 
     </button>
      <p className="main_para mt-1"> 
      { packageObject ? packageObject.description : '' } 
       </p>

     

              <button className="mt-1 btn_shopping w-100"> السعر : {packageObject ? packageObject.price : ''} ريال</button>

              {userAddedPackage ? (
      <div className='' >
      <button  className="mt-1 btn_shopping mx-2 bg_red w-100" onClick={() => removeCartFromDb() }  > ❌ الغاء   </button> 
                <div className="mt-1"></div>
      <button  className="btn_shopping bg_green w-100"  > ✅ تم الحجز  </button> 
    
      </div>
    
    ) : (
      <div className="w-100" onClick={() => addCartToDb() } >
      <button className="mt-1 btn_shopping bg_green w-100"  > اضافة الى السلة </button>
      </div>

     
    )}

             

  

      </div>

    </div>



    </div>



    <div className="package_section">

    <div className="d-flex-c text-right ">
    
    <div className="info_box"></div>
    <h1 className="main_headline">   الصور </h1>
    </div>
      

<div className="grid_photos_area mt-2">

        {packageObject.photos && packageObject.photos.map((item) => (
            <div className="single_package_img">
    <img  src={item} alt="" />
  
</div>
        )) }



</div>

    </div>

    <div className="place_sections mt-4 text-right package_section">

    <div className="d-flex-c text-right ">
    
    <div className="info_box"></div>
    <h1 className="main_headline">   أقسام المكان </h1>
    </div>
       
        <div className="mt-1"></div>
        
        <div className="d-flex-c f-wrap f-sp">
        {packageObject.sections  && packageObject.sections.map((item) => (
            <div className="single_place_section_div packge_custom_width ">

        <div className="section_img_div">
            <img src={item.image} alt="" />
            </div>

            <div className="section_info_div">
            <h1 className='mt-1' > {item.name} </h1>
            <div className="mt-1-small"></div>
            <p className='' >    {item.desc}  </p>
            </div>

        
        </div>
        )) }
        </div>
      


        

   

        </div>

    <div className="place_sections mt-4 text-right package_section">

    <div className="d-flex-c text-right ">
    
    <div className="info_box"></div>
    <h1 className="main_headline">    الموقع على الخريطة </h1>
    </div>
       
        <div className="mt-1"></div>
        
        {packageObject ? (
          <div className="flex-col">
          <iframe className='iframe_responsive' src={packageObject.location}  style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>

        ) : ''}


        </div>

        <div className="package_section mt-5">

<div className="d-flex-c text-right ">

<div className="info_box"></div>
<h1 className="main_headline">   البكجات </h1>
</div>
    
{loading ? (
      <>
      <SkeletonTheme baseColor="#e9e9e9" highlightColor="#e9e9e9">
<p>
  <Skeleton height={'20%'} width={'100%'} count={5} />
</p>
</SkeletonTheme>
                        </>
    ) : (
      <div className='mt-2' >

      
<div className="d-flex-c text-right mt-5 ">

<div className="info_box"></div>
<h1 className="main_headline">   بكجات المصورين </h1>
</div>

        <div className="grid_subpackages mt-3">
        { photographersArray && photographersArray.map(({  id , service_name , service_desc , service_provider  , price , rating , image }) => (
        <PackageComponent id={id} service_name={service_name} service_desc={service_desc} service_provider={service_provider} item_price={price} rating={rating} image={image} />
      )) }
        </div>


      <div className="d-flex-c text-right mt-5 ">

<div className="info_box"></div>
<h1 className="main_headline">   بكجات الفنادق </h1>
</div>

            <div className="grid_subpackages mt-3">
            { hotelArray && hotelArray.map(({  id , service_name , service_desc , service_provider  , price , rating , image }) => (
        <PackageComponent id={id} service_name={service_name} service_desc={service_desc} service_provider={service_provider} item_price={price} rating={rating} image={image} />
      )) }
            </div>


      <div className="d-flex-c text-right mt-5 ">

<div className="info_box"></div>
<h1 className="main_headline">   بكجات المرشدين السياحين </h1>
</div>

              <div className="grid_subpackages mt-3">

              { tourGuideArray && tourGuideArray.map(({  id , service_name , service_desc , service_provider  , price , rating , image }) => (
        <PackageComponent id={id} service_name={service_name} service_desc={service_desc} service_provider={service_provider} item_price={price} rating={rating} image={image} />
      )) }

              </div>



      </div>
    
    )}

</div>


   

  </div>

  <div className="section most_features_section container-sm">

<div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">    أكتشف التجارب السياحية </h1>
</div>

<div className="grid_packages mt-5">
{experinceArray && experinceArray.map(( { id , experince_name  , experince_photos , experince_price , experince_location } ) => (

<div className="single_experince_div" data-aos="fade-up-right" data-aos-delay="20" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250"  >

<Link to={`/experinces/${id}`}>
<img src={experince_photos[0]}  alt="" className="experince_img" />
</Link>


<div className=" body_experince_card">
<p className="location_experince_sm mt-1-small"> {experince_location} </p>

<h1 className="location_headline"> { experince_name }</h1>

<p className="experince_price mt-1"> سعر يبدأ من   <br /> <span className="span_bold">{experince_price} ريال </span> </p>

<Link to={`/experinces/${id}`}>
<div className="d-flex-c f-sp">

<button className="btn_category ">  احجز الان </button>

<img src="/images/icons/left-arrow-purple.png" alt="" className="icon_experince" />
</div>
</Link>

</div>

</div>

)) }




</div>

</div>
        
        <SideFooter />       
    <Footer />      


    </div>
  
  )
}

export default SinglePackage